// 将jsAPI转换为VUE插件

import JsApi from './lib/js_api'

function getJsApi() {
  return new JsApi()
}
const install = function (Vue) {
  Object.defineProperties(Vue.prototype, {
    $cjc: {
      get() {
        return getJsApi()
      }
    }
  })
}

export default install